// eslint-disable-next-line no-unused-vars
interface String {
    addSpace(): string;
}

String.prototype.addSpace = function (): string {
    return this.concat(' '); // This is explicit for accessibility purpose
};
